import React from 'react';
import useDialogConfig from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogConfig';
import Dialog from '../staff_invite';

export default function Launcher(props) {
  const config = useDialogConfig();

  return (
    <Dialog
      onClose={props.onClose}
      onSubmit={function(request) {
        queryClient.invalidateQueries({ queryKey: ['user'] });
      }}
    />
  );
};
